"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var KeyValueStore = require('./keyValueStore');

var _require = require('./utils/index'),
    throwIfUndefined = _require.throwIfUndefined,
    throwIfNotEqualLenArrays = _require.throwIfNotEqualLenArrays;

var ProfileStore =
/*#__PURE__*/
function (_KeyValueStore) {
  (0, _inherits2["default"])(ProfileStore, _KeyValueStore);

  function ProfileStore(name, linkProfile, replicator, threeId) {
    var _this;

    (0, _classCallCheck2["default"])(this, ProfileStore);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ProfileStore).call(this, name, replicator, threeId));
    _this._linkProfile = linkProfile;
    return _this;
  }

  (0, _createClass2["default"])(ProfileStore, [{
    key: "set",
    value: function () {
      var _set = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(key, value) {
        var opts,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                opts = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                throwIfUndefined(key, 'key'); // if this is the noLink call we shouldn't call _linkProfile.

                if (opts.noLink) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return this._linkProfile();

              case 5:
                return _context.abrupt("return", (0, _get2["default"])((0, _getPrototypeOf2["default"])(ProfileStore.prototype), "set", this).call(this, key, value));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function set(_x, _x2) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "setMultiple",
    value: function () {
      var _setMultiple = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(keys, values) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throwIfNotEqualLenArrays(keys, values);
                _context2.next = 3;
                return this._linkProfile();

              case 3:
                return _context2.abrupt("return", (0, _get2["default"])((0, _getPrototypeOf2["default"])(ProfileStore.prototype), "setMultiple", this).call(this, keys, values));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setMultiple(_x3, _x4) {
        return _setMultiple.apply(this, arguments);
      }

      return setMultiple;
    }()
  }]);
  return ProfileStore;
}(KeyValueStore);

module.exports = ProfileStore;